/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */

export const publicPathPrefix = '/public';
export const authPathPrefix = '/auth';
export const appPathPrefix = '/app';
export const adminPathPrefix = '/admin';

export const portfolioUpdateStartedQueryParams = ['?exec_rebalance=started'];

export const depositOrWithdrawStartedQueryParams = [
  '?deposit_crypto=started',
  '?sell_crypto=started',
];

export const portfolioUpdateExpiredQueryParams = ['?exec_rebalance=expired'];

export const buyOrSellExpiredQueryParams = [
  '?sell_crypto=expired',
  '?deposit_crypto=expired',
];

export const portfolioReusedQueryParams = [
  '?exec_rebalance=reused',
  '?sell_crypto=reused',
  '?deposit_crypto=reused',
];

/**
 * Notification is sent through the user notification system
 */
export const ignoredQueryParamsForLoggedInUser = [
  ...portfolioUpdateStartedQueryParams,
  ...depositOrWithdrawStartedQueryParams,
];
